import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useRestaurant } from '../context/RestaurantContext';
import './Header.css';

const Header = ({ user }) => {
  const { selectedRestaurant, setSelectedRestaurant } = useRestaurant();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setSelectedRestaurant(null); // Limpia el restaurante seleccionado al cerrar sesión
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };
  
  const handleChangeRestaurant = () => {
    setSelectedRestaurant(null); // Limpia la selección actual
    navigate('/seleccionar-restaurante'); // Envía al usuario a la pantalla de selección
  };

  // Esta función ahora busca el nombre completo en la lista de restaurantes del usuario
  const getRestaurantName = (id) => {
    if (!id || !user?.restaurants) return 'Cargando...';
    const restaurant = user.restaurants.find(r => r.id === id);
    return restaurant ? restaurant.name : 'No encontrado';
  };

  return (
    <header className="app-header">
      <div className="header-title">
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h1>Itacate Minero</h1>
        </Link>
      </div>
      <div className="header-actions">
        {/* Muestra el nombre del restaurante actual y el botón para cambiar */}
        {selectedRestaurant && (
            <span className="current-restaurant">
                {getRestaurantName(selectedRestaurant)}
            </span>
        )}
        {user && user.restaurants && user.restaurants.length > 1 && (
            <button onClick={handleChangeRestaurant} className="header-button">Cambiar</button>
        )}

        <Link to="/historial" className="header-button">Historial</Link>
        <Link to="/nueva-orden" className="header-button primary">Nueva Orden</Link>
        <button onClick={handleLogout} className="header-button">Cerrar Sesión</button>
      </div>
    </header>
  );
};

export default Header;